<template>
  <div class="container">
    <nav-bar :active.sync='active'></nav-bar>
    <components :is="comps[active]"></components>
  </div>
</template>
<script>
import navBar from './components/navBar' // 导航栏
import center from './components/center'
import myActive from './components/myActive'
import { getToken } from '@utils'
export default {
  components: { navBar, center, myActive },
  data() {
    return {
      active: '',
      comps: ['center', 'myActive']
    }
  },
  created() {
    if (getToken()) {
      this.active = 0
    }
  }
}
</script>
